import React, { useEffect, useRef } from "react";
import anime from "animejs/lib/anime.es.js";

export default function Home() {
    const pageRef = useRef(null);

    useEffect(() => {
      anime({
        targets: pageRef.current,
        opacity: [0, 1],
        translateY: [50, 0],
        duration: 3000,
        easing: "easeOutExpo"
      });
    }, []);

    return (
        <div className="container" ref={pageRef}>
            <div class="rect rect1"></div>
            <div class="rect rect2"></div>
            <div class="rect rect3"></div>

            <div className="home-container">
                <h1>Raytolfas - Главная страница</h1>
            </div>

            <div className="content-container">
                <img src="/raytolfas-banner.jpg" alt="alt-img" className="img-contents" />
                <h1>Сайт проекта Raytolfas</h1>
                <b>Тот самый проект!</b>
                <button onClick={() => window.location.href = "/sites"}>Перейти к сайтам</button>
            </div>

            <div className="content-container">
                <img src="https://arena.ua/wp-content/uploads/2017/07/1499775170.jpg" className="img-contents" alt="alt-img"></img>
                <h1>Партнёрки</h1>
                <button onClick={() => window.location.href = "/partners"}>Партнёки</button>
            </div>

            <div className="content-container">
                <img src="https://9to5google.com/wp-content/uploads/sites/4/2023/09/telegram-fi-01.webp?w=1600" className="img-contents" alt="alt-img"></img>
                <h1>Связь с администратором</h1>
                <button onClick={() => window.location.href = "https://t.me/MIXITOSIK_Give"}>Мой телеграмм</button>
            </div>

            <div className="content-container">
                <img src="https://img.freepik.com/free-photo/young-adult-organizing-documents_23-2149396633.jpg?semt=ais_hybrid&w=740" className="img-contents" alt="alt-img"></img>
                <h1>Наша документация (BETA)</h1>
                <button onClick={() => window.location.href = "https://docs.raytolfas.com"}>Документация</button>
            </div>
        </div>
    );
}
